import React from 'react';
import PropTypes from 'prop-types';

const VehicleTitle = ({ isMobile, vehicleTitle, supplementalTitle = '' }) => {
	const decodeMarkup = (encodedTitle) => {
		return { __html: `${encodedTitle}` };
	};

	if (vehicleTitle.length > 0) {
		if (supplementalTitle && !isMobile) {
			return (
				<div className="vehicle-title mr-4 my-0">
					<span
						className="d-block h6"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={decodeMarkup(
							supplementalTitle
						)}
					/>
					<span
						className="d-block h2"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={decodeMarkup(
							vehicleTitle.join(' ')
						)}
					/>
				</div>
			);
		}
		return (
			<div className="vehicle-title mr-4 my-0">
				{!isMobile ? (
					vehicleTitle.map((title, index) => (
						<span
							key={`${title}`}
							className={`d-block ${index === 0 ? 'h6' : 'h2'}`}
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={decodeMarkup(`${title}`)}
						/>
					))
				) : (
					<span
						className="h5 line-clamp-2"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={decodeMarkup(
							vehicleTitle.join(' ')
						)}
					/>
				)}
			</div>
		);
	} else {
		return null;
	}
};

export default VehicleTitle;

VehicleTitle.propTypes = {
	isMobile: PropTypes.bool,
	vehicleTitle: PropTypes.arrayOf(PropTypes.string),
	supplementalTitle: PropTypes.string
};
